import LoadingButton from "@mui/lab/LoadingButton"
import { TextField as MuiTextField } from "@mui/material"
import Avatar from "@mui/material/Avatar"
import { DateTime } from "luxon"
import React, { useState } from "react"

import i18n from "@/i18n"
import { useStore } from "@/store"

import type { LocalNote } from "./use_booking_state"

type NotesTabProps = {
  localNotes: LocalNote[]
  onAddNote: (note: string) => void
}

const NotesSection: React.FC<NotesTabProps> = ({ localNotes, onAddNote }) => {
  const [noteText, setNoteText] = useState("")
  const { currentUser } = useStore()

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 overflow-y-auto">
        {localNotes.length === 0 ? (
          <div className="flex items-center justify-center h-full text-gray-400 text-sm">
            {i18n.t("app.create_reservation.no_comments")}
          </div>
        ) : (
          <div className="py-4">
            {localNotes.map((note) => (
              <div key={note.id} className="flex flex-1 items-center space-x-4 px-6 py-2">
                <Avatar src={currentUser?.avatarUrl} />
                <div className="flex-1">
                  <div className="flex justify-between items-center">
                    <span className="text-xs text-gray-500 uppercase">
                      {currentUser?.firstName} {currentUser?.lastName}
                    </span>
                    <span className="text-xs text-gray-400">
                      {DateTime.fromISO(note.createdAt).toLocaleString(DateTime.DATETIME_MED)}
                    </span>
                  </div>
                  <div className="text-gray-800 py-1">{note.note}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="flex-shrink-0 border-t border-gray-200">
        <div className="flex items-center space-x-4 p-6">
          <Avatar src={currentUser?.avatarUrl} />
          <MuiTextField
            className="flex-1"
            multiline
            placeholder={i18n.t("app.reservation_note.add_form.placeholder")}
            value={noteText}
            onChange={(e) => setNoteText(e.target.value)}
            maxRows={4}
            minRows={1}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey && noteText.trim()) {
                e.preventDefault()
                onAddNote(noteText.trim())
                setNoteText("")
              }
            }}
          />
          <LoadingButton
            color="primary"
            type="button"
            disabled={!noteText.trim()}
            onClick={() => {
              if (noteText.trim()) {
                onAddNote(noteText.trim())
                setNoteText("")
              }
            }}
          >
            {i18n.t("app.reservation_note.add_form.submit")}
          </LoadingButton>
        </div>
      </div>
    </div>
  )
}

export default NotesSection
